import { render } from "./historyTable.vue?vue&type=template&id=a37f53e8&scoped=true"
import script from "./historyTable.vue?vue&type=script&lang=js"
export * from "./historyTable.vue?vue&type=script&lang=js"

import "./historyTable.vue?vue&type=style&index=0&id=a37f53e8&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a37f53e8"]])

export default __exports__